/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Products_UnauthorizedInputs */

const en_inventory_products_unauthorized = /** @type {(inputs: Inventory_Products_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to edit inventory products. Contact an administrator.`)
};

const es_inventory_products_unauthorized = /** @type {(inputs: Inventory_Products_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes permiso para editar productos de inventario. Contacta a un administrador.`)
};

/**
* | output |
* | --- |
* | "You don't have permission to edit inventory products. Contact an administrator." |
*
* @param {Inventory_Products_UnauthorizedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_products_unauthorized = /** @type {((inputs?: Inventory_Products_UnauthorizedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Products_UnauthorizedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_products_unauthorized(inputs)
	return es_inventory_products_unauthorized(inputs)
});